









import {
    defineComponent,
    PropType,
    computed,
} from '@vue/composition-api';

import type { PageHeaderActionItem } from './types';

export default defineComponent({
    name: 'SdsPageHeaderActions',
    props: {
        item: {
            type: Object as PropType<PageHeaderActionItem>,
            required: true,
        },
    },
    setup(props) {
        const handleClick = () => {
            if (typeof props.item?.onClick === 'function') {
                props.item.onClick();
            }
        };

        const buttonVariant = computed(() => props.item.selected ? 'primary' : 'tertiary');

        const iconName = computed(() => (props.item.selected ? `${props.item.icon}-filled` : props.item.icon));

        return {
            handleClick,
            buttonVariant,
            iconName,
        };
    },

});
